import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Icon } from '../../icon'
import { useTableContext } from '../context/table-provider'
import { Flex } from '../../flex'
import { PaginationActionsProps } from '../table.types'
import { Box } from '../../box'

const StyledTotalResults = styled.p`
  ${({ theme }) =>
    `
      display: inline-block;
      font-size: ${theme.fontSizes.bodySmall};
    `}
`

export const PaginationArrow = styled.button`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: none;
    border: none;
    padding: 0;
    margin: 0;
    font: inherit;
    color: inherit;
    text-align: inherit;
    outline: none;
    cursor: pointer;
    &:disabled {
      color: ${theme.colors.gray100};
      border-color: ${theme.colors.gray100};
    };
  `}
`

export const PaginationArrowsWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    gap: ${theme.sizes.xs};
  `}
`

export const PaginationContainer = styled.div`
  ${({ theme }) => `
    display: flex;
    gap: ${theme.sizes.xs};
    justify-content: space-between;

  `}
`

export function TablePagination({
  previousPage,
  nextPage,
  totalResultsText,
  rightContent,
}: PaginationActionsProps) {
  const { totalResults, isLoading } = useTableContext()
  const {
    i18n: { language: locale },
  } = useTranslation()

  // A null total is unknown (e.g. cursor-paginated endpoints): paginate anyway when there is a
  // page to move to, just without a results count
  const hasUnknownTotalWithPages =
    totalResults === null && Boolean(previousPage || nextPage)

  if (totalResults || hasUnknownTotalWithPages) {
    const formattedTotalResultsText =
      (totalResults &&
        totalResultsText?.replace(/\b\d+\b/g, (match) =>
          new Intl.NumberFormat(locale || 'en-US').format(parseInt(match))
        )) ||
      ''

    return (
      <PaginationContainer data-testid="table-pagination-container">
        <StyledTotalResults data-testid="total-results">
          {formattedTotalResultsText}
        </StyledTotalResults>
        <Flex gap="xl" justify="end" align="center">
          {rightContent && <Box>{rightContent}</Box>}
          <PaginationArrowsWrapper data-testid="pagination-arrows-wrapper">
            <PaginationArrow
              disabled={!previousPage || isLoading}
              onClick={() => previousPage?.()}
              aria-label="previous page"
              data-testid="back-button"
            >
              <Icon name="chevron-left" size={4} />
            </PaginationArrow>
            <PaginationArrow
              disabled={!nextPage || isLoading}
              onClick={() => nextPage?.()}
              aria-label="next page"
              data-testid="next-button"
            >
              <Icon name="chevron-right" size={4} />
            </PaginationArrow>
          </PaginationArrowsWrapper>
        </Flex>
      </PaginationContainer>
    )
  }

  return null
}
